import { Link } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

// US-003c — Access Denied surface. Rendered by AppLayout when the
// signed-in user's role is not permitted to access the current path.
// Differs from /login (unauthenticated) and /404 (route doesn't
// exist): you ARE signed in, the route DOES exist, you just can't
// see it.

export function Forbidden403() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-destructive/10 text-destructive">
          <ShieldAlert className="h-7 w-7" />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Access denied</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You don&apos;t have permission to view this page. If you believe this is a mistake,
          contact your administrator.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
